import styled from 'styled-components';
import { Utils } from 'billon-ui';

const { Text } = Utils;

export const CardTitle = styled(Text)`
  font-weight: 600;
  font-size: 20px;
  margin: 0 0 30px 0;
`;
